import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
	selector: 'xp-stat',
	standalone: true,
	templateUrl: './xp-stat.component.html',
	styleUrls: ['./xp-stat.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpStatComponent {
	label = input('');
	value = input<string | number | null>('');
}
